if (!customElements.get('load-more')) {

  class LoadMore extends HTMLElement {
    constructor() {
      super();

      // Global identifiers
      this.targetWrapper = '[data-loader-target]';
      this.targetListArr = '[data-loader-list]';
      this.template = document.querySelector('[data-loader-target]').dataset.loaderTemplate;

      this.paginationPrevAttr = '[data-pagination-prev]';
      this.paginationNextAttr = '[data-pagination-next]';

      this.initPagination();
    }

    initPagination() {
      this.loadMoreButtons = this.querySelectorAll('[data-load-button]');
      this.loadMoreButtons.forEach(button => button.addEventListener('click', this.loadContent.bind(this)));
    }

    updatePagination(direction, existingLoadPrev, fetchedLoadPrev, existingLoadNext, fetchedLoadNext) {
      if (direction === 'next') {
        existingLoadNext.innerHTML = fetchedLoadNext.innerHTML;
      } else {
        existingLoadPrev.innerHTML = fetchedLoadPrev.innerHTML;
      }
    }

    loadContent(event) {

      // Prevent route change
      event.preventDefault();
      event.stopImmediatePropagation();

      // Destructure to get what we need
      const { currentTarget } = event
      const { href } = currentTarget;

      // Get full url and get current search params
      const url = new URL(`${href}`);
      const params = new URLSearchParams(url.search);

      // Set of overwrite url view parameter
      params.set('view', this.template);

      // New url to fetch
      const newUrl = ` ${url.origin}${url.pathname}?${params.toString()}`;

      // Prev or next page?
      const direction = currentTarget.dataset.loadDirection;

      // Update interface elements
      currentTarget.querySelector('[data-load-text]').hidden = true;
      currentTarget.querySelector('[data-loader]').hidden = false;

      // Fetch the products
      this.fetchContent(newUrl, href, direction);
    }

    /**
     * updateURLHash
     * @param {String} url
    */
    updateURLHash(url) {
      history.pushState('', '', url);
    }

    /**
     * fetchContent
     * @description Renders the products based on the fetch url data.
     * @param {String} url
     * @param {String} page
     * @param {String} direction
    */
    async fetchContent(url, href, direction) {

      try {
        // Fetch content
        const response = await fetch(url);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        // Existing variables
        const existingProductsList = this.querySelector(this.targetListArr);
        const existingLoadPrev = this.querySelector(this.paginationPrevAttr);
        const existingLoadNext = this.querySelector(this.paginationNextAttr);

        // Return if wrapper is not found
        if (!html.querySelector(this.targetWrapper)) return;

        // Fetched variables
        const fetchedContentList = html.querySelector(this.targetListArr);
        const fetchedContent = document.createRange().createContextualFragment(fetchedContentList.innerHTML);
        const fetchedLoadPrev = html.querySelector(this.paginationPrevAttr);
        const fetchedLoadNext = html.querySelector(this.paginationNextAttr);

        // Add the products to the existing list
        (direction === 'next') ? existingProductsList.append(fetchedContent) : existingProductsList.prepend(fetchedContent);

        this.updatePagination(direction, existingLoadPrev, fetchedLoadPrev, existingLoadNext, fetchedLoadNext);

        // Re-init pagination. Otherwise it won't work
        this.initPagination();

        // update url
        this.updateURLHash(href);
      } catch (error) {
        console.log(error);
      }
    }
  }

  window.LoadMore = LoadMore;
  customElements.define('load-more', LoadMore);
}